import * as React from 'react'

import { HEADER } from '../../utils/dataTrackingValues'
import * as Styled from './Header.styles'

const MegaMenu = ({ data, Link = null, featuredContent = null }) => (
  <Styled.MegaMenu>
    <div className="subnav">
      <div className="subnav-container">
        <Styled.MegaMenuTitle>{data.text}</Styled.MegaMenuTitle>
        <ul>
          {data.subnav.map((subitem) => {
            const nav = subitem?.megaLinks || subitem.subnav
            return nav ? (
              <div key={subitem.text}>
                <span className="mega-menu-subheading">
                  <Link
                    to={subitem?.link || subitem.href}
                    onClick={
                      () =>
                        HEADER.LINKS.handleClick(
                          subitem.text,
                          subitem?.link || subitem.href
                        )
                      // eslint-disable-next-line react/jsx-curly-newline
                    }
                  >
                    {subitem.text}
                  </Link>
                </span>
                {nav.map((item) => (
                  <li key={item.text}>
                    <Link
                      to={item?.link || item.href}
                      onClick={
                        () =>
                          HEADER.LINKS.handleClick(
                            subitem.text,
                            subitem?.link || subitem.href
                          )
                        // eslint-disable-next-line react/jsx-curly-newline
                      }
                    >
                      {item.text}
                    </Link>
                  </li>
                ))}
              </div>
            ) : (
              <li key={subitem.text}>
                <Link
                  to={subitem?.link || subitem.href}
                  onClick={
                    () =>
                      HEADER.LINKS.handleClick(
                        subitem.text,
                        subitem?.link || subitem.href
                      )
                    // eslint-disable-next-line react/jsx-curly-newline
                  }
                >
                  {subitem.text}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
      {featuredContent && (
        <Styled.FeaturedContent>{featuredContent}</Styled.FeaturedContent>
      )}
    </div>
  </Styled.MegaMenu>
)

export default MegaMenu
